export class ErrorResponse {
    public message!: string;
    public statusText!: string;
    public statusCode!: number;
}
